import React from 'react';
import { PropTypes } from 'prop-types';

import ProjectCardSortSummary from './components/project-card-sort-summary';
import ProjectTreeTestSummary from './components/project-tree-test-summary';
import ProjectSurveySummary from './project-survey-summary';
import testTypes from '../../../core/constants/testTypes';

const ProjectSummarySection = (props) => {
  const {
    edit,
    baseUrl,
    history,
    values,
    onPreviewStudy,
    testType,
    smallColumn,
    previewButtonClicked,
  } = props;

  switch (testType) {
    case testTypes.CARD_SORT: {
      return (
        <ProjectCardSortSummary
          baseUrl={baseUrl}
          history={history}
          values={values}
          onPreviewStudy={onPreviewStudy}
          previewButtonClicked={previewButtonClicked}
          smallColumn={smallColumn}
        />
      );
    }
    case testTypes.TREE_TEST: {
      return (
        <ProjectTreeTestSummary
          baseUrl={baseUrl}
          history={history}
          values={values}
          onPreviewStudy={onPreviewStudy}
          previewButtonClicked={previewButtonClicked}
          smallColumn={smallColumn}
        />
      );
    }
    case testTypes.SURVEY: {
      return (
        <ProjectSurveySummary
          edit={edit}
          baseUrl={baseUrl}
          history={history}
          values={values}
          onPreviewStudy={onPreviewStudy}
          smallColumn={smallColumn}
        />
      );
    }
    default: return null;
  }
};

ProjectSummarySection.propTypes = {
  edit: PropTypes.func,
  values: PropTypes.shape({
    instructionsContent: PropTypes.string,
    instructionsTitle: PropTypes.string,
    thankYouContent: PropTypes.string,
    thankYouTitle: PropTypes.string,
    tooltipDescription: PropTypes.bool,
    welcomeContent: PropTypes.string,
    welcomeTitle: PropTypes.string,
    sortType: PropTypes.string,
    cardSortItems: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        description: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    cardSortCategories: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  baseUrl: PropTypes.string,
  onPreviewStudy: PropTypes.func,
  previewButtonClicked: PropTypes.bool,
  testType: PropTypes.string.isRequired,
  smallColumn: PropTypes.bool,
};

ProjectSummarySection.defaultProps = {
  edit: undefined,
  baseUrl: undefined,
  onPreviewStudy: undefined,
  history: {},
  smallColumn: false,
  previewButtonClicked: false,
};

export default ProjectSummarySection;
